import React, { useEffect, useState } from 'react';
import goodalipi from 'src/plugins/goodalipi';

const EXTERNAL_BASE ="https://user-hrwin.medibuddy.in/creation-user-benef"

export default function UserBenefCreation() {
  const [iframeUrl, setIframeUrl] = useState("");

  useEffect(() => {
    try {
      // Get token from goodalipi (HRWIN way)
      const user = goodalipi?.get('user');
      const accessToken =
        user?.accessToken?.longToken ||
        user?.accessToken ||
        "";

      const finalUrl = accessToken
        ? `${EXTERNAL_BASE}?accessToken=${encodeURIComponent(accessToken)}`
        : EXTERNAL_BASE;

      console.log("Iframe URL:", finalUrl);
      setIframeUrl(finalUrl);

    } catch (error) {
      console.error("Error getting token:", error);
    }
  }, []);

  if (!iframeUrl) {
    return <div>Loading...</div>;
  }

  return (
    <div
      style={{
        height: "95%",
        marginTop: "15px",
        marginLeft: "15px",
        marginRight: "10px",
      }}
    >
      <div
        style={{
          border: "1px solid #ddd",
          height: "100%",
          borderRadius: "16px",
          overflow: "hidden"
        }}
      >
        <iframe
          src={iframeUrl}
          width="100%"
          height="100%"
          title="User Beneficiary Creation"
          frameBorder="0"
          style={{ border: "none" }}
        />
      </div>
    </div>
  );
}